import React from 'react';
import { useLocation } from 'react-router-dom';
import { LISTING_REQUEST_BANNER_END_AT_MS } from '../../../Interface/ListingRequest';
import ListingRequestCta from '../../Abstracts/ListingRequest/ListingRequestCta/ListingRequestCta';
import { useListingRequestEnabled } from '../../Hooks/useListingRequestEnabled';
import { useUser } from '../../Context/UserContext';

/**
 * Launch communication for the listing request feature (P-4972): a static
 * strip below the menu bar on every page, shown from the launch instant until
 * LISTING_REQUEST_BANNER_END_AT (exclusive). The start page with the customer
 * dashboard (P-5094) is the exception: its listing request panel carries the
 * same sentence and call to action, so the banner is left out there
 * (Marketing 20.10.2026). The start is gated on
 * useListingRequestEnabled, so employees previewing before launch see the
 * banner too; after the end date it disappears on its own while the feature
 * stays reachable through search and the product lists. The date check runs
 * at render time - a tab left open across the boundary picks the change up on
 * its next render or navigation; do not add a timer for this.
 */
export default function ListingRequestBanner() {
  const listingRequestEnabled = useListingRequestEnabled();
  const { pathname } = useLocation();
  const { user } = useUser();

  if (
    !listingRequestEnabled ||
    Date.now() >= LISTING_REQUEST_BANNER_END_AT_MS
  ) {
    return <></>;
  }

  // The start page with the customer dashboard (P-5094) has the sentence and the call to
  // action in the dashboard's listing request panel, so the banner would repeat them there.
  const followedByDashboard = pathname === '/' && !!user?.dashboard_enabled;
  if (followedByDashboard) {
    return <></>;
  }

  // Below lg several pages (order confirmation, product lists) start without top spacing and
  // relied on the white space of the header, so the banner brings its own (T-16531).
  return <ListingRequestCta source="banner" className="mb-4 mb-lg-0" />;
}
